import { createSlice } from "@reduxjs/toolkit";
import {
    fetchCourseTableColumnNames,
    fetchAllCourses,
    createCourses,
    updateCourses,
    deleteCourses,
    activateDeactivateCourses,
    uploadCourseIcon
} from "./thunk";
import { toast } from "react-toastify";

const coursesSlice = createSlice({
  name: "courses",
  initialState: {
    icon: "",
    courses: [],
    tableColumnNames: [],
    loading: false, // For general list loading
    imageLoad: false, // For icon/image upload loading
    loadings: false, // For table column names loading
    error: null,
    uploadedImageUrl: null, // For storing the URL of the uploaded course icon
  },
   reducers: {
    clearUploadedCourseImageUrl: (state) => {
      state.uploadedImageUrl = null;
    }
  },
  extraReducers: (builder) => {
    builder

    // Fetch Course Table Column Names
    .addCase(fetchCourseTableColumnNames.pending, (state) => {
      state.loadings = true;
      state.error = null;
    })
    .addCase(fetchCourseTableColumnNames.fulfilled, (state, action) => {
      state.loadings = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchCourseTableColumnNames.rejected, (state, action) => {
      state.loadings = false;
      state.error = action.payload;
    })

    // Get All Courses
    .addCase(fetchAllCourses.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchAllCourses.fulfilled, (state, action) => {
      state.loading = false;
      state.courses = action.payload;
    })
    .addCase(fetchAllCourses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // Add Course
    .addCase(createCourses.pending, (state) => {
      state.error = null;
    })
    .addCase(createCourses.fulfilled, (state, action) => {
      state.courses = [action.payload.data[0], ...state.courses];
      // toast.success(action.payload.message);
    })
    .addCase(createCourses.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Update Course
    .addCase(updateCourses.pending, (state) => {
      state.error = null;
    })
    .addCase(updateCourses.fulfilled, (state, action) => {
      const index = state.courses.findIndex(
        (item) => item.ID === action.payload[0].ID
      );

      // if (index !== -1) {
      //   state.courses[index] = action.payload[0];
      // }

      // toast.success("Updated successfully");

      if (index >= 0) {
        state.courses[index] = action.payload[0];
        // toast.success("Updated successfully");
      }
    })
    .addCase(updateCourses.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Delete Course
    .addCase(deleteCourses.pending, (state) => {
      state.error = null;
    })
    .addCase(deleteCourses.fulfilled, (state, action) => {
      const deletedIds = action.payload.map((item) => item.ID);

      // Filter out the deleted items
      state.courses = state.courses.filter((item) => !deletedIds.includes(item.ID));

    })
    .addCase(deleteCourses.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Active Deactive Course
    .addCase(activateDeactivateCourses.pending, (state) => {
      state.error = null;
    })
    .addCase(activateDeactivateCourses.fulfilled, (state, action) => {
      if (action.payload) {
        const updatedCourse = action.payload[0] || {};


        state.courses = state.courses.map((item) => item.ID === updatedCourse.ID ? {...item, IsActive: updatedCourse.IsActive} : item)
      }
    })
    .addCase(activateDeactivateCourses.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(uploadCourseIcon.pending, (state, action) => {
      state.imageLoad = true;
      state.error = null;
    })
    .addCase(uploadCourseIcon.fulfilled, (state, action) => {
      state.imageLoad = false;
      state.uploadedImageUrl = action.payload; // Store URL in the correct state property
    })
    .addCase(uploadCourseIcon.rejected, (state, action) => {
      state.imageLoad = false;
      state.error = action.payload;
    })
  },
});

export const { clearUploadedCourseImageUrl } = coursesSlice.actions;
export default coursesSlice.reducer;
